import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import SelectList from "app/Components/Shared/SelectList/SelectList";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import {
  checkServiceAndGetSubscribers, setError, setSelectedSubscriber, StepsEnum, setStep, init, saveToHistory
} from "app/Components/Block/CellularDataOnOff/CellularDataOnOffSlice";
import Checkbox from "app/Components/Shared/CheckBox/Checkbox";
import {prepareUrl} from "app/utilities/StringHelpers/StringHelpers";
import EpiContext from "@episerver/spa-core/Spa";

const BuyServiceStep = (props) => {
  const [isChecked, setIsChecked] = useState(false);
  const {
    error,
    subscriberList, selectedSubscriber
  } = props.cellularDataOnOffSlice;

  const {setStep, setError, saveToHistory} = props;

  const {
    serviceSoc: {
    expandedValue: [{
      offerID: { value: offerID },
      price: { value: price },
      subTitle: { value: subTitle },
      socName: { value: socName },
    }]
  }
  } = props.contentData;

  useEffect(() => {
    saveToHistory("buyService");
  }, []);

  const onSubmit = async () => {
    setError(null)
    if (!isChecked) {
      setError('יש לאשר את תנאי השימוש');
    }
  }


  return (
    <div className={'buy-service-container'}>
      <div className={'title-container'}>
      <span className={'title'}>
        {socName}
      </span>
        {subscriberList.length === 1 ? (
          <span className={'title'}>
          למנוי <span className={'purple'}>{selectedSubscriber}</span>
        </span>
        ) : (
          <>
            <span className={'subTitle'}>המנויים עליהם יותקן השירות:</span>
            <div className={'service-recipients-container'}>
              {subscriberList && subscriberList.map((subscriber) => (
                <span className={'recipient'} key={subscriber.key}>
                {subscriber.key}
              </span>
              ))}
            </div>
          </>
        )}
      </div>
      <div className={'package-info'}>
      <span className={'package-description'}>{subTitle}</span>
        <span className={'package-price'}>₪{price} לחודש</span>
      </div>
      <div className={'terms-and-conditions-checkbox-container'}>
        <Checkbox
          id='terms-checkbox'
          onCheck={() => setIsChecked(true)}
          onUncheck={() => setIsChecked(false)}
          checked={isChecked}>
          <span className={"terms-string"}> אני מאשר\ת את </span>
          <a className='terms-link' href='#' onClick={() => prepareUrl(props.contentData?.moreInfoLink?.value)}> תנאי
            השימוש </a>
        </Checkbox>
      </div>
      <div className={'bottom-container'}>
        <span className={'error'}>{error}</span>
        <BtnSubmit text={'להתקנה'} onclick={onSubmit}/>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cellularDataOnOffSlice: state.cellularDataOnOffSlice,
  };
};

const mapDispatchToProps = {
  setSelectedSubscriber,
  checkServiceAndGetSubscribers,
  setError,
  setStep,
  init,
  saveToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyServiceStep);
